export const appVersion = "0.8.84";
